import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAreasDropdownOpen, setIsAreasDropdownOpen] = useState(false);
  const location = useLocation();

  // Close dropdown when menu closes
  useEffect(() => {
    if (!isMenuOpen) {
      setIsAreasDropdownOpen(false);
    }
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsAreasDropdownOpen(false);
  };

  const toggleAreasDropdown = () => {
    setIsAreasDropdownOpen(!isAreasDropdownOpen);
  };

  const isAreasActive = location.pathname.startsWith('/areas-of-focus');

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          <img src="/images/logo.png" alt="Alicia Gostylo Counseling Logo" className="nav-logo-image" />
          <div className="nav-logo-text">
            <h1>Alicia Gostylo</h1>
            <span>Counseling</span>
          </div>
        </Link>
        
        <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <Link 
            to="/" 
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Home
          </Link>
          <Link 
            to="/meet-alicia" 
            className={`nav-link ${location.pathname === '/meet-alicia' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Meet Alicia
          </Link>
          <Link 
            to="/my-approach" 
            className={`nav-link ${location.pathname === '/my-approach' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            My Approach
          </Link>
          <Link 
            to="/services" 
            className={`nav-link ${location.pathname === '/services' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Services
          </Link>
          <div className="nav-dropdown">
            <button 
              className={`nav-link dropdown-toggle ${isAreasActive ? 'active' : ''}`}
              onClick={toggleAreasDropdown}
            >
              Areas of Focus
              <span className="dropdown-arrow">▼</span>
            </button>
            <div className={`dropdown-menu ${isAreasDropdownOpen ? 'active' : ''}`}>
              <Link 
                to="/areas-of-focus" 
                className="dropdown-item"
                onClick={closeMenu}
              >
                Overview
              </Link>
              <Link 
                to="/areas-of-focus/grief" 
                className="dropdown-item"
                onClick={closeMenu}
              >
                Grief
              </Link>
              <Link 
                to="/areas-of-focus/dreams" 
                className="dropdown-item"
                onClick={closeMenu}
              >
                Dreams
              </Link>
              <Link 
                to="/areas-of-focus/spiritual-integration" 
                className="dropdown-item"
                onClick={closeMenu}
              >
                Spiritual Integration
              </Link>
            </div>
          </div>
          <Link 
            to="/resources" 
            className={`nav-link ${location.pathname === '/resources' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Resources
          </Link>
          <Link 
            to="/faqs" 
            className={`nav-link ${location.pathname === '/faqs' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            FAQs
          </Link>
          <Link 
            to="/contact" 
            className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Contact
          </Link>
        </div>
        
        <div className="nav-toggle" onClick={toggleMenu}>
          <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
